<template>
  <form name="pay"
        method="post"
        content="application/json">
    <input type="hidden" name="payMethod" value="CARD">
    <input type="hidden" name="goodsNm" :value="goodsNm">
    <input type="hidden" name="ordNo" :value="ordNo">
    <input type="hidden" name="goodsAmt" :value="goodsAmt">
    <input type="hidden" name="ordNm" :value="ordNm">
    <input type="hidden" name="ordTel" :value="ordTel">
    <input type="hidden" name="returnUrl" :value="returnUrl">
    <input type="hidden" name="ordEmail" :value="ordEmail">
    <input type="hidden" name="mbsUsrId" :value="mbsUsrId">
  </form>
  <teleport to="body">
    <iframe v-if="isShow"
            style="width: 100%; height: 100%; z-index: 9999 !important; display: block; overflow: hidden; position: fixed; top: 0;"
            name="popupPay"></iframe>
  </teleport>
</template>

<script setup>
import {defineExpose, defineEmits, nextTick, onMounted, ref} from "vue";

const emits = defineEmits(['rgst', 'syserr']);

const goodsNm = ref('');
const ordNo = ref('');
const goodsAmt = ref('');
const ordNm = ref('');
const ordTel = ref('');
const returnUrl = ref('');
const ordEmail = ref('');
const mbsUsrId = ref('');

const isShow = ref(false);

const show = (rgstParams) => {
  setRgstParams(rgstParams);

  isShow.value = true;
  nextTick(() => {
    document.pay.action = "/onpay/p1/bill/v1/payform";
    document.pay.target = "popupPay";

    window.addEventListener('message', rgstResultMessageListner);

    document.pay.submit();
  });
}

const rgstResultMessageListner = async (event) => {
  isShow.value = false;
  clearRgstParams();
  const data = event.data;
  const {type, params} = data;

  if (type == 'finish') {
    const result = JSON.parse(params);
    const rgstParams = {
      resultCd: result.resultCd,
      resultMsg: result.resultMsg,
      issuCdcoCd: result.appCardCd,
      issuCdcoNm: result.fnNm,
      mskngCrdNo: result.cardNo,
      bcrtno: result.bid,
    };
    emits('rgst', rgstParams);
  } else if (type != 'cancel') {
    emits('syserr');
  }
};

const setRgstParams = (rgstParams) => {
  goodsNm.value = String(rgstParams.goodsNm);
  ordNo.value = String(Date.now().toString()); // 주문번호 관리를 하지않음으로 자동생성처리
  goodsAmt.value = String('0'); // 상품금액 0으로 고정 처리 (빌링키 발급 매뉴얼 참고)
  ordNm.value = String(rgstParams.ordNm);
  ordTel.value = String(rgstParams.ordTel).replace(/[^0-9]/g, '');

  const {host, protocol} = window.location;
  returnUrl.value = `${protocol}//${host}`;

  ordEmail.value = String(rgstParams.ordEmail);
  mbsUsrId.value = String(rgstParams.mbsUsrId);
};

const clearRgstParams = () => {
  goodsNm.value = '';
  ordNo.value = '';
  goodsAmt.value = '';
  ordNm.value = '';
  ordTel.value = '';
  ordEmail.value = '';
  mbsUsrId.value = '';
};

defineExpose({
  show
});

onMounted(() => {
})
</script>

<style scoped>

</style>
